import { useCallback, useId, useState } from "react";

export function useResetState() {
  const id = useId();
  const [key, setKey] = useState<boolean>(false);

  const reset = useCallback(() => {
    setKey((key) => !key);
  }, []);

  return { key: `${key}-${id}`, reset };
}
